import { render } from "./ThreadView.vue?vue&type=template&id=38897f39"
import script from "./ThreadView.vue?vue&type=script&lang=js"
export * from "./ThreadView.vue?vue&type=script&lang=js"

import "./ThreadView.vue?vue&type=style&index=0&id=38897f39&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ThreadView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38897f39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38897f39', __exports__)) {
    api.reload('38897f39', __exports__)
  }
  
  module.hot.accept("./ThreadView.vue?vue&type=template&id=38897f39", () => {
    api.rerender('38897f39', render)
  })

}


export default __exports__